// extracted by mini-css-extract-plugin
export default {"List":"List_List__OXulq"};